import { LabelHTMLAttributes } from "react"
import { twMerge } from "tailwind-merge"

interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
    text?: string
}

export function Error({ text, ...rest }: LabelProps) {
    return (
        <label
            {...rest} 
            className={twMerge("tw-justify-start tw-items-start tw-font-semibold tw-text-sm tw-mb-1 tw-text-primary", rest.className)}
        >
            ** {text}
        </label>
    )
}
